import { useDispatch, useSelector } from "react-redux";
import "../manage.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  removePosition,
  setPositionOnEdit,
  setPositions,
} from "../../Redux/Actions/pozicioneActions";

const ManageOpenPositions = () => {
  const dispatch = useDispatch();

  const [positions, setPositionsList] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const loggedUser = useSelector((state) => state.users.loggedUser);
  const isLoggedIn = Object.keys(loggedUser || {}).length > 0;

  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    const fetchPositions = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          `https://api.arkiva.gov.al/api/open-positions?page=${currentPage}&limit=20`,
        );

        const sortedPositions = Array.isArray(response.data.positions)
          ? [...response.data.positions].sort(
              (a, b) => new Date(b.announceDate) - new Date(a.announceDate),
            )
          : [];

        setPositionsList(sortedPositions);
        setTotalPages(response.data.totalPages);

        dispatch(setPositions(sortedPositions));
      } catch (error) {
        console.error("Error fetching positions:", error);
      }

      setLoading(false);
    };

    if (isLoggedIn) {
      fetchPositions();
    } else {
      navigate("/login");
    }
  }, [dispatch, isLoggedIn, navigate, currentPage]);

  const formatDate = (dateValue) => {
    if (!dateValue) {
      return "-";
    }

    const date = new Date(dateValue);

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  };

  const editPosition = (position) => {
    dispatch(setPositionOnEdit(position));
    navigate(`/manage/pozicione-vakante/${position._id}`);
  };

  const addPosition = () => {
    navigate("/manage/pozicione-vakante/add-new");
  };

  const deletePosition = async (position) => {
    try {
      const response = await axios.delete(
        `https://api.arkiva.gov.al/api/open-positions/delete/${position._id}`,
        { data: { id: position.id } },
      );
      if (response.data.message === "error") {
        alert("Something went wrong!");
      } else {
        setPositionsList((prevPositions) =>
          prevPositions.filter((p) => p._id !== response.data.positionId),
        );
        dispatch(removePosition(response.data.positionId));
      }
    } catch (error) {
      console.error("Error deleting position:", error);
    }
  };

  const filteredPositions = positions.filter((item) =>
    item.title.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="manage-page">
      {loading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}

      <div className="manage-page-header">
        <div className="manage-page-header-actions">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button onClick={addPosition}>
            <i className="fa-solid fa-plus"></i> Shto Pozicion Vakant
          </button>
        </div>
      </div>

      <div className="manage-table">
        <table>
          <thead>
            <tr>
              <th style={{ width: "55%" }}>Titulli</th>
              <th style={{ width: "15%" }}>Data e shpalljes</th>
              <th style={{ width: "15%" }}>Data e përfundimit</th>
              <th style={{ width: "15%" }}>Veprime</th>
            </tr>
          </thead>

          <tbody>
            {filteredPositions.length > 0 ? (
              filteredPositions.map((item) => (
                <tr key={item._id}>
                  <td>{item.title}</td>

                  <td>{formatDate(item.announceDate)}</td>

                  <td>{formatDate(item.finalDate)}</td>

                  <td className="actions" data-label="Veprime">
                    <button onClick={() => editPosition(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>

                    <button onClick={() => deletePosition(item)}>
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">Nuk u gjetën pozicione vakante!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button
          className={`pagination-control-btn ${
            currentPage === 1 ? "disabled" : ""
          }`}
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        >
          ← Para
        </button>

        <span className="pagination-current-page">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className={`pagination-control-btn ${
            currentPage === totalPages ? "disabled" : ""
          }`}
          disabled={currentPage === totalPages}
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
        >
          Pas &#8594;
        </button>
      </div>
    </div>
  );
};

export default ManageOpenPositions;
